import { useLanguage } from '../context/LanguageContext';
import { useTranslate } from './useTranslate';
import type { LocalizedText } from '../utils/siteContent';

export function useLocalizedText(value: LocalizedText | string | undefined, fallback = '') {
  const { language } = useLanguage();
  const englishSource = typeof value === 'string' ? value : value?.en || '';
  const chineseSource = typeof value === 'string' ? '' : value?.zh || '';
  const translatedChinese = useTranslate(englishSource);

  if (language === 'zh') {
    return chineseSource || translatedChinese || englishSource || fallback;
  }

  return englishSource || chineseSource || fallback;
}
